<template>
  <div class="bg-white rounded-lg shadow-sm border border-gray-200">
    <div class="p-4 border-b border-gray-200 flex flex-col sm:flex-row items-start sm:items-center justify-between space-y-3 sm:space-y-0">
      <div class="flex items-center space-x-3">
        <span class="material-symbols-outlined text-xl text-primary">workspace_premium</span>
        <h2 class="text-lg font-semibold text-gray-800">Subscription</h2>
      </div>
      <div class="flex flex-col sm:flex-row items-stretch sm:items-center space-y-2 sm:space-y-0 sm:space-x-2 w-full sm:w-auto">
        <router-link 
          to="/upgrade"
          class="w-full sm:w-auto inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-full shadow-sm text-white bg-primary hover:bg-primary-dark transition-all"
        >
          <span class="material-symbols-outlined text-sm mr-1">rocket_launch</span>
          {{ profile?.plan?.active ? 'Upgrade' : 'Reactivate' }}
        </router-link>
        <router-link 
          to="/subscription-management"
          class="w-full sm:w-auto inline-flex items-center justify-center px-4 py-2 border border-primary text-sm font-medium rounded-full shadow-sm text-primary bg-white hover:bg-primary-lighter transition-all"
        >
          <span class="material-symbols-outlined text-sm mr-1">settings</span>
          Manage
        </router-link>
      </div>
    </div>
    <div class="p-4 sm:p-6">
      <div class="space-y-6 sm:space-y-8">
        <!-- Current Plan Status -->
        <div class="flex items-start space-x-4">
          <div class="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-primary to-primary-dark rounded-xl flex items-center justify-center shadow-sm">
            <span class="material-symbols-outlined text-2xl text-white">workspace_premium</span>
          </div>
          <div class="flex-1">
            <p class="text-sm font-medium text-gray-500 text-left">Current Plan</p>
            <p class="mt-1 text-xl sm:text-2xl font-bold text-gray-900 capitalize text-left">{{ profile?.plan?.name || 'Free' }}</p>
            <div class="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold mt-3 shadow-sm"
              :class="{'bg-gradient-to-r from-green-100 to-green-200 text-green-800 border border-green-200': profile?.plan?.active, 
                       'bg-gradient-to-r from-red-100 to-red-200 text-red-800 border border-red-200': !profile?.plan?.active}">
              <span class="material-symbols-outlined text-xs mr-1" 
                    :class="profile?.plan?.active ? 'text-green-600' : 'text-red-600'">
                {{ profile?.plan?.active ? 'check_circle' : 'error' }}
              </span>
              {{ profile?.plan?.active ? 'Active' : 'Inactive' }}
            </div>
          </div>
        </div>

        <!-- Last Payment Info -->
        <div v-if="profile?.plan?.lastPaymentDate" class="flex items-start space-x-4 p-4 bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl border border-green-100">
          <div class="flex-shrink-0 w-12 h-12 bg-white rounded-xl flex items-center justify-center shadow-sm">
            <span class="material-symbols-outlined text-green-600 text-xl">payments</span>
          </div>
          <div class="flex-1 min-w-0">
            <p class="text-sm font-medium text-gray-500 text-left">Last Payment</p>
            <div class="mt-1 flex flex-col sm:flex-row sm:items-center sm:space-x-2">
              <span class="text-lg font-bold text-gray-900 text-left">
                {{ formatCurrency(profile?.plan?.lastPaymentAmount, profile?.plan?.currency) }}
              </span>
              <span class="text-sm text-gray-500 text-left">on {{ formatDate(profile?.plan?.lastPaymentDate) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubscriptionCard',
  props: {
    profile: {
      type: Object,
      default: null
    }
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '';
      return date.toLocaleDateString('en-ZA', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    },
    formatCurrency(amount) {
      if (typeof amount !== 'number' || isNaN(amount) || amount === 0) return '';
      return `$${amount.toFixed(2)}`;
    }
  }
};
</script>

<style scoped>
/* Enhanced gradients and shadows */
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}

.shadow-sm {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

/* Responsive adjustments */
@media (max-width: 640px) {
  .space-y-6 > * + * {
    margin-top: 1.5rem;
  }
  
  .space-y-8 > * + * {
    margin-top: 1.5rem;
  }
}
</style>
